import { useEffect, useState } from "react";
import { api } from "./api.js";

export function useSetupState() {
  const [state, setState] = useState(null);
  const [error, setError] = useState(null);

  const refresh = async () => {
    try {
      const s = await api("/setup/state", { auth: false });
      setState(s);
    } catch (err) {
      setError(err);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return { state, error, refresh };
}
